import { Route, Routes, UrlSegment, UrlSegmentGroup } from '@angular/router';

import { SiteLayoutComponent } from './_layout/site-layout/site-layout.component';

import { CourseComponent } from './course/course.component';
import { ErrorComponent } from './error/error.component';
import { guideRoutes } from './guide/guide.routes';
import { LearnComponent } from './learn/learn.component';
import { ManageComponent } from './manage/manage.component';
import { ReportComponent } from './report/report.component';
import { ResultsComponent } from './results/results.component';
import { TeamMemberComponent } from './team/individual-member/team-member.component';
import { TeamMemberGuard } from './team/individual-member/team-member.guard';
import { TeamProfileComponent } from './team/profile/team-profile.component';
import { TeamInsightsCommunicationComponent } from './team/team-insights/communication/team-teaminsights-communication.component';
import { TeamInsightsProblemSolvingComponent } from './team/team-insights/problem-solving/team-teaminsights-problem-solving.component';
import { TeamComponent } from './team/team.component';
import { TemplatesComponent } from './templates/templates.component';
import { TopicComponent } from './topic/topic.component';

export const appRoutes: Routes = [
  //Site routes goes here
  {
    path: '',
    component: SiteLayoutComponent,
    children: [
      { matcher: firstTimeLogin, redirectTo: '/results?ft=y' },
      { path: 'course', component: CourseComponent },
      { path: 'learn', component: LearnComponent },
      { path: 'manage', component: ManageComponent },
      { path: 'results', component: ResultsComponent },
      { path: 'report', component: ReportComponent },
      { path: 'templates', component: TemplatesComponent },
      { path: 'team/profile', component: TeamProfileComponent },
      { path: 'team/problem-solving', component: TeamInsightsProblemSolvingComponent },
      { path: 'team/communication-styles', component: TeamInsightsCommunicationComponent },
      { path: 'team', component: TeamComponent },
      {
        path: 'team/:id',
        canActivate: [TeamMemberGuard],
        component: TeamMemberComponent,
      },
      { path: '', redirectTo: 'team', pathMatch: 'full' }, // Default is team results page
    ],
  },
  //no layout routes
  { path: 'topic', component: TopicComponent },
  { path: 'guide', children: guideRoutes },

  // otherwise redirect to 404
  { path: '**', component: ErrorComponent, pathMatch: 'full' },
];

export function firstTimeLogin(url: UrlSegment[]) {
  if (location.href.includes('goto=results')) {
    url = [new UrlSegment('results', {})];
    return {
      consumed: url,
    };
  }
  return null;
}

export function hasMatchingRedirectTarget(url: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  if (url.length <= 1 && route.redirectTo) {
    const currentPath = location.pathname.toLowerCase();
    let target = new URLSearchParams(location.search).get('target');

    // Prevent redirecting if the target is missing or matches the current path
    if (!target || `/${target.toLowerCase()}` === currentPath) {
      return null;
    }

    let candidate = target;
    if (candidate) {
      // Normalize the candidate path
      if (candidate.startsWith('/')) {
        candidate = candidate.slice(1);
      }
      candidate = candidate.toLowerCase();
    }

    console.log('Current Path:', currentPath);
    console.log('Target:', target);
    console.log('Candidate:', candidate);
    console.log('Redirect To:', route.redirectTo);

    if (candidate && typeof route.redirectTo === 'string' && candidate === route.redirectTo.slice(1)) {
      if (`/${candidate}` === currentPath) {
        return null; // Prevent redirecting to the same route
      }
      return { consumed: url, posParams: { target: new UrlSegment(target, {}) } };
    }
  }
  return null;
}
